module.exports = __webpack_public_path__ + "media/images/flags/cl-71b8727fe63a18b583aa5c5a1ada6d16.svg";